<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>View Temp Customer Information</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <div class="action-btn">
                                    <button pButton pRipple label="" icon="las la-plus" title="Add" (click)="GoToCreate($event)"
                                        class="p-button-success p-mr-2"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>

                            <p-table #dt [value]="CustomersInformationList" [scrollable]="true" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" scrollHeight="200px">
                               
                                <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:100px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <!-- <col style="width:250px"> -->
                                    </colgroup>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="agentNo">Temp Customer Name <p-sortIcon field="agentNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">Temp Customer Type <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="fatherName">Company Type<p-sortIcon field="fatherName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Credit Type <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Billing Cycle <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Customer Site <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Acquired By agent/Direct<p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">GSTIN <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Name of the Product <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Type of Product <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Billing to<p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Google City Name  <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Comments <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <!-- <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th> -->
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_CustomerInformationList>
                                    <tr>
                                        <td>
                                            {{_CustomerInformationList.agentNo}}
                                        </td>
                                        <td>
                                            {{_CustomerInformationList.agentName}}
                                        </td>
                                        <td>
                                            {{_CustomerInformationList.fatherName}}
                                        </td>
                                        <td>
                                            {{_CustomerInformationList.mobileNo}}
                                        </td>
                                        <td>
                                            {{_CustomerInformationList.mobileNo}}
                                        </td>
                                        <td>
                                            {{_CustomerInformationList.mobileNo}}
                                        </td>
                                        <td>
                                            {{_CustomerInformationList.mobileNo}}
                                        </td>
                                        <td>
                                            {{_CustomerInformationList.mobileNo}}
                                        </td>
                                        <td>
                                            {{_CustomerInformationList.mobileNo}}
                                        </td>
                                        <td>
                                            {{_CustomerInformationList.mobileNo}}
                                        </td>
                                        <td>
                                            {{_CustomerInformationList.mobileNo}}
                                        </td>
                                        <td>
                                            {{_CustomerInformationList.mobileNo}}
                                        </td>
                                        <td>
                                            {{_CustomerInformationList.mobileNo}}
                                        </td>
                                        <!-- <td>
                                            {{_CustomerInformationList.mobileNo}}
                                        </td> -->
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

